import React from "react";

import { useTranslation } from "react-i18next";

import * as styles from "./styles";

export function NoRoute() {
  const { t } = useTranslation("localContent");

  return (
    <div className={styles.container}>
      <p data-testid="no-route-title" className={styles.title}>
        {t("commute.results.noRoute")}
      </p>
      <p data-testid="no-route-description" className={styles.description}>
        {t("commute.results.trySuggestion")}
      </p>
    </div>
  );
}
